import { render } from "./CoockieBanner.vue?vue&type=template&id=dab07722"
import script from "./CoockieBanner.vue?vue&type=script&lang=js"
export * from "./CoockieBanner.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__